import { Attachments } from 'modules/Assets/Attachments'
import isEqual from 'lodash/isEqual'
import type { ServerAsset } from '@sequencehq/api/utils/commonModels'
import {
  useSelectBillingScheduleAttachments,
  useShouldDisableModifyBillingScheduleAttachments,
  useStoreBillingScheduleAttachments
} from 'Cube/domain/subdomain/attachments'
import { useEffect, useState } from 'react'
import { usePerformContractExtraction } from 'ContractExtraction/index'
import { useCurrentInspectorAsset } from './useCurrentInspectorAsset'

export const BillingScheduleAttachments = ({
  defaultAttachment,
  onSelectedPreviewChange
}: {
  defaultAttachment?: ServerAsset
  onSelectedPreviewChange?: () => void
}) => {
  const attachments = useSelectBillingScheduleAttachments()
  const storeAttachments = useStoreBillingScheduleAttachments()
  const disableModifyAttachments =
    useShouldDisableModifyBillingScheduleAttachments()
  const { setCurrentInspectorAsset } = useCurrentInspectorAsset()

  const handleAttachmentChange = (assets: ServerAsset[]) => {
    if (
      !isEqual(
        assets.map(({ id }) => id),
        attachments.map(({ id }) => id)
      )
    ) {
      storeAttachments(assets)
    }
  }

  const [attachmentToPreview, setAttachmentToPreview] = useState<
    ServerAsset | undefined
  >(defaultAttachment)

  const { performExtraction, isEnabled: isPerformExtractionEnabled } =
    usePerformContractExtraction()

  const handleAllUploadsComplete = (assets: ServerAsset[]) => {
    if (assets.length !== 1 || !isPerformExtractionEnabled) {
      return
    }

    performExtraction(assets[0].id)
    setAttachmentToPreview(assets[0])
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: ensure current asset is cleared when inspector is closed
  useEffect(() => {
    return () => {
      setCurrentInspectorAsset(null)
    }
  }, [])

  return (
    <Attachments
      attachmentToPreview={attachmentToPreview}
      initialAttachments={attachments}
      onChange={handleAttachmentChange}
      onAllUploadsComplete={handleAllUploadsComplete}
      disableModifyAttachments={disableModifyAttachments}
      onSelectedPreviewChange={asset => {
        onSelectedPreviewChange?.()
        setCurrentInspectorAsset(asset)
      }}
    />
  )
}
